
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("8k046", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");


var $dh538 = parcelRequire("dh538");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $9g0TQ = parcelRequire("9g0TQ");


var $fUfR2 = parcelRequire("fUfR2");


var $i8IAc = parcelRequire("i8IAc");


var $7DSoa = parcelRequire("7DSoa");


var $djwkb = parcelRequire("djwkb");


var $bTcnb = parcelRequire("bTcnb");

const $b18298ec40df52db$var$PENDING_LINK_STATUSES = [
    (0, $5TXU5.SmartLinkStatus).Pending,
    (0, $5TXU5.SmartLinkStatus).Resolving
];
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b18298ec40df52db$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, placeholderData: placeholderData, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $i8IAc.useAISummaryConfig)();
    const resolve = (0, $7DSoa.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $eIleF.useSmartLinkContext)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    // if we have placeholder state it means we can internally use it
    // as temporary resolved data until the actual data comes back as one of the final statuses
    const placeholderCardState = (0, $42omo.useMemo)(()=>$b18298ec40df52db$var$PENDING_LINK_STATUSES.includes(status) && placeholderData && (0, $9g0TQ.extractPlaceHolderCardState)(placeholderData), [
        placeholderData,
        status
    ]);
    const placeHolderStatus = placeholderCardState ? placeholderCardState.status : undefined;
    const context = (0, $42omo.useMemo)(()=>(0, $bTcnb.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: placeholderCardState ? placeholderCardState.details : details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: placeholderCardState ? placeHolderStatus : status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        aiSummaryConfig,
        appearance,
        actionOptions,
        details,
        id,
        isPreviewPanelAvailable,
        onAuthorize,
        onClick,
        openPreviewPanel,
        origin,
        placeholderCardState,
        placeHolderStatus,
        renderers,
        resolve,
        status,
        url,
        fireEvent
    ]);
    const flexibleCardContext = (0, $42omo.useMemo)(()=>({
            data: context,
            status: placeHolderStatus ?? status,
            ui: ui
        }), [
        context,
        placeHolderStatus,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $42omo.useEffect)(()=>{
        switch(status){
            case (0, $5TXU5.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url,
                    ...(0, $dh538.fg)('expose-product-details-from-smart-card') && {
                        extensionKey: details?.meta?.key
                    }
                });
                break;
            case (0, $5TXU5.SmartLinkStatus).Errored:
            case (0, $5TXU5.SmartLinkStatus).Fallback:
            case (0, $5TXU5.SmartLinkStatus).Forbidden:
            case (0, $5TXU5.SmartLinkStatus).NotFound:
            case (0, $5TXU5.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url,
        details?.meta?.key
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fUfR2.FlexibleCardContext).Provider, {
        value: flexibleCardContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $djwkb.default), {
        testId: testId,
        ...ui,
        onClick: onClick,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        actionOptions: actionOptions,
        status: status,
        retry: retry
    }, children));
};
var $b18298ec40df52db$export$2e2bcd8739ae039 = $b18298ec40df52db$var$FlexibleCard;
module.exports["default"] = $b18298ec40df52db$export$2e2bcd8739ae039;

});

parcelRegister("9g0TQ", function(module, exports) {
const $6e579b1e6cb4cfe2$var$isValidPlaceholderData = (placeholderData)=>placeholderData?.data && 'url' in placeholderData.data && 'name' in placeholderData.data;
const $6e579b1e6cb4cfe2$export$684541b2632ffbbc = (placeholderData)=>{
    return $6e579b1e6cb4cfe2$var$isValidPlaceholderData(placeholderData) ? {
        status: 'resolved',
        metadataStatus: undefined,
        details: placeholderData
    } : undefined;
};
module.exports["extractPlaceHolderCardState"] = $6e579b1e6cb4cfe2$export$684541b2632ffbbc;

});

parcelRegister("djwkb", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $179om = parcelRequire("179om");


var $9E8aG = parcelRequire("9E8aG");


var $5znEc = parcelRequire("5znEc");


var $ipYFb = parcelRequire("ipYFb");


var $3eIDF = parcelRequire("3eIDF");

const $a624e70f21d764cf$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $179om.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
            if ((0, $9E8aG.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5TXU5.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5TXU5.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $a624e70f21d764cf$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child) && (0, $9E8aG.isFlexibleUiBlock)(child) ? child : undefined);
}; /**
    * Note: This function is only necessary for CompiledCSS within Jest tests due to the way it handles Styles.
    * CompiledCSS will inject a StyleCacheProvider around the component tree, which
    * causes the children to be wrapped in a StyleCacheProvider as well. This function recursively
    * searches for the first valid TitleBlock within the children of the StyleCacheProvider.
    */ 
const $a624e70f21d764cf$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return undefined;
    if (node.type === (0, $5znEc.default)) return node;
    if ((0, $9E8aG.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $a624e70f21d764cf$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $a624e70f21d764cf$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).map((child)=>$a624e70f21d764cf$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(block)) return block.props;
};
const $a624e70f21d764cf$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $a624e70f21d764cf$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eIDF.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $a624e70f21d764cf$var$baseStyleCommon = null;
const $a624e70f21d764cf$var$backgroundStyles = null;
const $a624e70f21d764cf$var$elevationStyles = null;
const $a624e70f21d764cf$var$clickableContainerStyles = null;
const $a624e70f21d764cf$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
}; /**
    * Get container padding based on smart link size
    * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
    * at view/FlexibleCard/components/utils.tsx
    */ 
const $a624e70f21d764cf$var$getPadding = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $a624e70f21d764cf$var$getGap = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $a624e70f21d764cf$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $a624e70f21d764cf$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
}; /**
    * A container is a hidden component that build the Flexible Smart Link.
    * All the Flexible UI components are wrapped inside the container.
    * It inherits the ui props from Card component and applies the custom styling
    * accordingly.
    * @internal
    * @see Block
    */ 
const $a624e70f21d764cf$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5TXU5.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $fBMbo.di)((0, $ipYFb.default));
    const padding = hidePadding ? '0px' : $a624e70f21d764cf$var$getPadding(size);
    const gap = $a624e70f21d764cf$var$getGap(size);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $a624e70f21d764cf$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && (status === 'resolved' || hoverPreviewOptions?.render !== undefined); // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const isResolved = status === 'resolved';
    const isUnresolvedWithAuthFlow = status !== 'resolved' && retry !== undefined;
    const hasHoverCardOverride = hoverPreviewOptions?.render !== undefined;
    const canShowHoverCard = showHoverPreview && (isResolved || isUnresolvedWithAuthFlow || hasHoverCardOverride);
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $a624e70f21d764cf$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $a624e70f21d764cf$var$previewOnLeftStyleMap[size],
            previewOnRight && $a624e70f21d764cf$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itia51 _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $7sObp.default)(padding),
            "--_73mooq": (0, $7sObp.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $7sObp.default)(previewOnRight ? gap : padding)
        }
    }, clickableContainer ? $a624e70f21d764cf$var$getLayeredLink(testId, context, children, onClick) : null, $a624e70f21d764cf$var$filterChildren(children, removeBlockRestriction));
    if (context?.url && ((0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view') ? canShowHoverCard : canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ipYFb.default), {
        isHoverPreview: (0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view') ? isResolved || hasHoverCardOverride : canShowHoverPreview,
        isAuthTooltip: (0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view') ? isUnresolvedWithAuthFlow : canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions
    }, container);
    return container;
};
var $a624e70f21d764cf$export$2e2bcd8739ae039 = $a624e70f21d764cf$var$Container;
module.exports["default"] = $a624e70f21d764cf$export$2e2bcd8739ae039;

});

parcelRegister("179om", function(module, exports) {
const $bb043bc0c2a9f6db$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);
module.exports["isFlexUiPreviewPresent"] = $bb043bc0c2a9f6db$export$783c1bf8fee63f80;

});

parcelRegister("ipYFb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $90Y9A = parcelRequire("90Y9A");

const $7470566bbae8322c$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $7470566bbae8322c$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $7470566bbae8322c$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $42omo.useState)(true);
    const mouseStopTimer = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $42omo.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5TXU5.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`,
        role: 'presentation'
    }, children));
};
var $7470566bbae8322c$export$2e2bcd8739ae039 = $7470566bbae8322c$var$HoverCardControl;
module.exports["default"] = $7470566bbae8322c$export$2e2bcd8739ae039;

});

parcelRegister("90Y9A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $fBMbo = parcelRequire("fBMbo");


var $1DWH0 = parcelRequire("1DWH0");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $3eMTN = parcelRequire("3eMTN");


var $5MkWK = parcelRequire("5MkWK");


var $cD2gN = parcelRequire("cD2gN");

const $1ecced62c01f09fc$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $fBMbo.di)((0, $cD2gN.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $5MkWK.useSmartLinkAnalyticsContext)({
        display: (0, $5TXU5.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $cD2gN.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $42omo.useCallback)((error, info)=>{
        (0, $bIll3.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $bIll3.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $bIll3.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMTN.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cD2gN.HoverCardComponent), props, children)));
};
const $1ecced62c01f09fc$var$HoverCardWithoutAnalyticsContext = (0, $1DWH0.default)()($1ecced62c01f09fc$var$HoverCardWithErrorBoundary);
const $1ecced62c01f09fc$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ecced62c01f09fc$var$HoverCardWithoutAnalyticsContext, props);
};
const $1ecced62c01f09fc$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ecced62c01f09fc$export$57a077cc9fbe653e, props);
module.exports["HoverCard"] = $1ecced62c01f09fc$export$57a077cc9fbe653e;
module.exports["StandaloneHoverCard"] = $1ecced62c01f09fc$export$f1f63acbe6ed8fb0;

});

parcelRegister("cD2gN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $iu6m9 = parcelRequire("iu6m9");


var $5TXU5 = parcelRequire("5TXU5");


var $a43ao = parcelRequire("a43ao");


var $4QzTV = parcelRequire("4QzTV");


var $lz9QA = parcelRequire("lz9QA");


var $5MkWK = parcelRequire("5MkWK");


var $7MOSf = parcelRequire("7MOSf");


var $2Stw8 = parcelRequire("2Stw8");


var $aSUnJ = parcelRequire("aSUnJ");

const $4bda3cea16c08f4a$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $4bda3cea16c08f4a$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $4bda3cea16c08f4a$var$FADE_IN_DELAY = 500;
const $4bda3cea16c08f4a$var$FADE_OUT_DELAY = 300;
const $4bda3cea16c08f4a$var$RESOLVE_DELAY = 100;
const $4bda3cea16c08f4a$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $aSUnJ.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, shouldRenderToParent: shouldRenderToParent = false, label: label, titleId: titleId, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $4bda3cea16c08f4a$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const fadeOutTimeoutId = (0, $42omo.useRef)();
    const fadeInTimeoutId = (0, $42omo.useRef)();
    const resolveTimeOutId = (0, $42omo.useRef)();
    const mousePos = (0, $42omo.useRef)();
    const popupOffset = (0, $42omo.useRef)();
    const parentSpan = (0, $42omo.useRef)(null);
    const renderers = (0, $4QzTV.useSmartLinkRenderers)();
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const handleSetIsOpen = (0, $42omo.useCallback)((isOpen)=>{
        setIsOpen(isOpen);
        onVisibilityChange?.(isOpen);
    }, [
        onVisibilityChange
    ]);
    const { loadMetadata: loadMetadata, register: register } = (0, $a43ao.useSmartCardActions)(id, url);
    const setMousePosition = (0, $42omo.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $aSUnJ.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $aSUnJ.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $42omo.useCallback)(()=>{
        if (handleSetIsOpen) handleSetIsOpen(false);
        else setIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $42omo.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $4bda3cea16c08f4a$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $42omo.useEffect)(()=>()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $42omo.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            if ((0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view')) {
                if (linkState.status === 'pending') // Link hasn't been registered yet. Register and resolve link.
                register();
                else // Link has been already been partially resolved. Load metadata.
                loadMetadata();
            } else loadMetadata();
        }, $4bda3cea16c08f4a$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata,
        register
    ]);
    const initShowCard = (0, $42omo.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) {
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            } else fadeInTimeoutId.current = setTimeout(()=>{
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen
    ]);
    const onActionClick = (0, $42omo.useCallback)((actionId)=>{
        if (actionId === (0, $5TXU5.ActionName).PreviewAction || actionId === (0, $5TXU5.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $42omo.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $42omo.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $42omo.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $42omo.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id,
            hoverPreviewOptions: hoverPreviewOptions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MkWK.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview,
            id: id,
            source: $4bda3cea16c08f4a$export$421dbc3834daf261
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Stw8.default), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id,
        hoverPreviewOptions
    ]);
    const trigger = (0, $42omo.useCallback)(({ 'aria-haspopup': _ariaHasPopup, 'aria-expanded': _ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ref: parentSpan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ...triggerProps,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseOver: initShowCard,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": $4bda3cea16c08f4a$var$HOVER_CARD_TRIGGER_WRAPPER,
            ...(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true) ? {
                className: $4bda3cea16c08f4a$var$HOVER_CARD_TRIGGER_WRAPPER
            } : {}
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    const popupComponent = (0, $42omo.useMemo)(// Within the Popup component, if shouldRenderToParent, the zIndex prop is ignored
    // as it is assumed that the custom popup container has the desired styles
    ()=>(0, $7MOSf.createCustomPopupContainer)(shouldRenderToParent ? zIndex : undefined), [
        zIndex,
        shouldRenderToParent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        shouldRenderToParent: shouldRenderToParent,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: popupComponent
    });
};
module.exports["HOVER_CARD_SOURCE"] = $4bda3cea16c08f4a$export$421dbc3834daf261;
module.exports["HoverCardComponent"] = $4bda3cea16c08f4a$export$e2173dafa6a751bb;

});

parcelRegister("7MOSf", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $52ec9dab657c3c9f$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        ref: ref
    }, children));
const $52ec9dab657c3c9f$export$c98f335200f1c8df = (zIndex)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...props,
            ref: ref,
            ...zIndex !== undefined && {
                style: {
                    ...props.style,
                    zIndex: zIndex
                }
            }
        }, children));
};
var $52ec9dab657c3c9f$export$2e2bcd8739ae039 = $52ec9dab657c3c9f$var$CustomPopupContainer;
module.exports["createCustomPopupContainer"] = $52ec9dab657c3c9f$export$c98f335200f1c8df;

});

parcelRegister("2Stw8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $eIleF = parcelRequire("eIleF");


var $dh538 = parcelRequire("dh538");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $226XV = parcelRequire("226XV");


var $lz9QA = parcelRequire("lz9QA");


var $ivUmx = parcelRequire("ivUmx");


var $kbh18 = parcelRequire("kbh18");


var $6wQZE = parcelRequire("6wQZE");


var $aSUnJ = parcelRequire("aSUnJ");


var $kwHRh = parcelRequire("kwHRh");


var $1pQH9 = parcelRequire("1pQH9");


var $2FHby = parcelRequire("2FHby");


var $3Yue4 = parcelRequire("3Yue4");


var $84jjJ = parcelRequire("84jjJ");


var $5GuAS = parcelRequire("5GuAS");

const $44ed84e93427a03a$export$34883cbaea18402d = 'smart-links-hover-preview';
const $44ed84e93427a03a$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions, hoverPreviewOptions: hoverPreviewOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const extensionKey = (0, $42omo.useMemo)(()=>(0, $226XV.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $42omo.useMemo)(()=>(0, $226XV.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, product: product } = (0, $eIleF.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $kbh18.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $226XV.getServices)(linkState.details);
    const statusRef = (0, $42omo.useRef)(linkStatus);
    const fireEventRef = (0, $42omo.useRef)(fireEvent);
    const definitionIdRef = (0, $42omo.useRef)(definitionId);
    (0, $42omo.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $42omo.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $42omo.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $ivUmx.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $kwHRh.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    // Platform apps (Home, Goals, Projects, and Teams) should by default open in the same tab when the FF is enabled.
    const isSameTabAlignmentEnabled = (0, $dh538.fg)('townsquare-same-tab-alignment-gcko-849');
    const anchorTarget = product === 'ATLAS' && isSameTabAlignmentEnabled ? '_self' : undefined;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5TXU5.SmartLinkSize).Large,
        position: (0, $5TXU5.SmartLinkPosition).Center,
        subtitle: subtitle,
        ...isSameTabAlignmentEnabled ? {
            anchorTarget: anchorTarget
        } : undefined
    };
    const uiOptions = (0, $aSUnJ.flexibleUiOptions);
    uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5TXU5.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $42omo.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        const overrideView = hoverPreviewOptions?.render?.();
        if (overrideView) return overrideView;
        if (cardState.status === 'errored' && (0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view')) return null;
        if ((0, $dh538.fg)('navx-2478-sl-fix-hover-card-unresolved-view') ? cardState.status === 'resolving' || cardState.metadataStatus === 'pending' : cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $84jjJ.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5GuAS.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FHby.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Yue4.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1pQH9.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url
    }, cardView) : null;
};
var $44ed84e93427a03a$export$2e2bcd8739ae039 = $44ed84e93427a03a$var$HoverCardContent;
module.exports["hoverCardClassName"] = $44ed84e93427a03a$export$34883cbaea18402d;
module.exports["default"] = $44ed84e93427a03a$export$2e2bcd8739ae039;

});

parcelRegister("aSUnJ", function(module, exports) {

var $dTk3A = parcelRequire("dTk3A");


var $5TXU5 = parcelRequire("5TXU5");

const $695b1b58e53b929b$export$8245b0eaabf3440c = (0, $dTk3A.layers).modal();
const $695b1b58e53b929b$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5TXU5.SmartLinkSize).Medium,
    zIndex: $695b1b58e53b929b$export$8245b0eaabf3440c + 1
};
const $695b1b58e53b929b$export$a0a37c997fbcd678 = 24;
const $695b1b58e53b929b$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card
module.exports["HOVER_CARD_Z_INDEX"] = $695b1b58e53b929b$export$8245b0eaabf3440c;
module.exports["flexibleUiOptions"] = $695b1b58e53b929b$export$8e022b7269e8199a;
module.exports["CARD_WIDTH_REM"] = $695b1b58e53b929b$export$a0a37c997fbcd678;
module.exports["CARD_GAP_PX"] = $695b1b58e53b929b$export$e7cae8c75d768024;

});

parcelRegister("kwHRh", function(module, exports) {

var $aliCf = parcelRequire("aliCf");


var $5TXU5 = parcelRequire("5TXU5");


var $imb12 = parcelRequire("imb12");

const $11f68d60f03aaf1c$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $aliCf.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5TXU5.ElementName).AuthorGroup,
            (0, $5TXU5.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn,
                    (0, $5TXU5.ElementName).SubscriberCount,
                    (0, $5TXU5.ElementName).State
                ],
                subtitle: [
                    (0, $5TXU5.ElementName).SourceBranch,
                    (0, $5TXU5.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5TXU5.ElementName).LatestCommit,
                    (0, $5TXU5.ElementName).CollaboratorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $imb12.extractOwnedBy)(data) ? (0, $5TXU5.ElementName).OwnedByGroup : (0, $5TXU5.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5TXU5.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5TXU5.ElementName).ReactCount,
                    (0, $5TXU5.ElementName).CommentCount,
                    (0, $5TXU5.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5TXU5.ElementName).AssignedToGroup,
                        (0, $5TXU5.ElementName).State,
                        (0, $5TXU5.ElementName).StoryPoints,
                        (0, $5TXU5.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5TXU5.ElementName).CollaboratorGroup,
                    (0, $5TXU5.ElementName).State,
                    (0, $5TXU5.ElementName).DueOn
                ],
                secondary: [
                    (0, $5TXU5.ElementName).ReactCount,
                    (0, $5TXU5.ElementName).CommentCount,
                    (0, $5TXU5.ElementName).AttachmentCount,
                    (0, $5TXU5.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5TXU5.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn,
                    (0, $5TXU5.ElementName).State,
                    (0, $5TXU5.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).State,
                    (0, $5TXU5.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5TXU5.ElementName).ReactCount,
                    (0, $5TXU5.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $11f68d60f03aaf1c$var$AvatarGroupsWithNamePrefix = [
    (0, $5TXU5.ElementName).AssignedToGroup,
    (0, $5TXU5.ElementName).OwnedByGroup,
    (0, $5TXU5.ElementName).AuthorGroup
];
const $11f68d60f03aaf1c$var$toElementItem = (name)=>{
    const showNamePrefix = $11f68d60f03aaf1c$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $11f68d60f03aaf1c$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5TXU5.ElementName)).map($11f68d60f03aaf1c$var$toElementItem);
};
const $11f68d60f03aaf1c$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $11f68d60f03aaf1c$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $11f68d60f03aaf1c$var$toElementItems(metadata.subtitle),
        primary: $11f68d60f03aaf1c$var$toElementItems(primary),
        secondary: $11f68d60f03aaf1c$var$toElementItems(metadata.secondary)
    };
};
module.exports["getMetadata"] = $11f68d60f03aaf1c$export$8548546c0aa631e6;

});

parcelRegister("imb12", function(module, exports) {

var $lyclm = parcelRequire("lyclm");

var $dLFOH = parcelRequire("dLFOH");

var $9WUug = parcelRequire("9WUug");

var $4P3K9 = parcelRequire("4P3K9");

var $4sK6R = parcelRequire("4sK6R");

var $79vw2 = parcelRequire("79vw2");

const $4af8820ea221ff5f$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $4af8820ea221ff5f$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $4af8820ea221ff5f$export$b68822b76d5d51d5 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'schema:commentCount');
const $4af8820ea221ff5f$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && $4af8820ea221ff5f$export$b68822b76d5d51d5(response?.data);
};
const $4af8820ea221ff5f$export$4356c594f5c138d6 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $4af8820ea221ff5f$export$ac56bd7a37249b48 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'endTime');
const $4af8820ea221ff5f$export$e57334ce4738e29d = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:viewCount');
const $4af8820ea221ff5f$export$44130aa92252501 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:reactCount');
const $4af8820ea221ff5f$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && $4af8820ea221ff5f$export$44130aa92252501(response?.data);
};
const $4af8820ea221ff5f$export$c8bef3d5e550a3a = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:voteCount');
const $4af8820ea221ff5f$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $4P3K9.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4af8820ea221ff5f$export$5546969a505305 = (data)=>{
    const person = (0, $dLFOH.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $4af8820ea221ff5f$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $dLFOH.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $4af8820ea221ff5f$export$69b10d653f96288b = (data)=>{
    const persons = (0, $9WUug.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4af8820ea221ff5f$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $4sK6R.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $4af8820ea221ff5f$export$43e54589935a1ff = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'schema:programmingLanguage');
const $4af8820ea221ff5f$export$949ac6a8325b3fdb = (data)=>$4af8820ea221ff5f$var$extractLinkName(data['atlassian:mergeSource']);
const $4af8820ea221ff5f$export$8bd03a7beb5badf1 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:subscriberCount');
const $4af8820ea221ff5f$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $4af8820ea221ff5f$export$65362ff78a97fd8 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:attachmentCount');
const $4af8820ea221ff5f$export$29b0ac5d2f9890cf = (data)=>$4af8820ea221ff5f$var$extractLinkName(data['atlassian:mergeDestination']);
const $4af8820ea221ff5f$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $4af8820ea221ff5f$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $4af8820ea221ff5f$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $4af8820ea221ff5f$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $4af8820ea221ff5f$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $4af8820ea221ff5f$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $4af8820ea221ff5f$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $4af8820ea221ff5f$export$cc4028b2878d0675 = (data)=>{
    return $4af8820ea221ff5f$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $4af8820ea221ff5f$export$b592ddecae70b61d = (data)=>{
    return $4af8820ea221ff5f$var$extractValue(data, 'dateSent');
};
const $4af8820ea221ff5f$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdAt;
    return response?.data && $4af8820ea221ff5f$export$b592ddecae70b61d(response?.data);
};
const $4af8820ea221ff5f$export$bdcea84d1550eb9d = (data)=>{
    return $4af8820ea221ff5f$var$extractValue(data, 'atlassian:storyPoints');
};
const $4af8820ea221ff5f$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $4af8820ea221ff5f$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $4af8820ea221ff5f$export$92037aea7f27bf7f = (meta)=>meta.tenantId;
const $4af8820ea221ff5f$export$f222ff3355b608d8 = (response)=>{
    try {
        const url = (0, $79vw2.extractSmartLinkUrl)(response);
        const hostName = url ? new URL(url).hostname : undefined;
        return hostName;
    } catch  {
        return undefined;
    }
};
module.exports["extractSmartLinkCommentCount"] = $4af8820ea221ff5f$export$fb0960a89fb9c17b;
module.exports["extractAppliedToComponentsCount"] = $4af8820ea221ff5f$export$4356c594f5c138d6;
module.exports["extractDueOn"] = $4af8820ea221ff5f$export$ac56bd7a37249b48;
module.exports["extractViewCount"] = $4af8820ea221ff5f$export$e57334ce4738e29d;
module.exports["extractSmartLinkReactCount"] = $4af8820ea221ff5f$export$bb52c21c67a309ca;
module.exports["extractVoteCount"] = $4af8820ea221ff5f$export$c8bef3d5e550a3a;
module.exports["extractOwnedBy"] = $4af8820ea221ff5f$export$75b4b5a156f48ff3;
module.exports["extractAssignedTo"] = $4af8820ea221ff5f$export$5546969a505305;
module.exports["extractPersonAssignedToAsArray"] = $4af8820ea221ff5f$export$edb8a7a44b91274e;
module.exports["extractProgrammingLanguage"] = $4af8820ea221ff5f$export$43e54589935a1ff;
module.exports["extractSourceBranch"] = $4af8820ea221ff5f$export$949ac6a8325b3fdb;
module.exports["extractSubscriberCount"] = $4af8820ea221ff5f$export$8bd03a7beb5badf1;
module.exports["extractTeamMemberCount"] = $4af8820ea221ff5f$export$9fc8706c6cb5343a;
module.exports["extractAttachmentCount"] = $4af8820ea221ff5f$export$65362ff78a97fd8;
module.exports["extractTargetBranch"] = $4af8820ea221ff5f$export$29b0ac5d2f9890cf;
module.exports["extractChecklistProgress"] = $4af8820ea221ff5f$export$dd980f9881b65d9c;
module.exports["extractLocation"] = $4af8820ea221ff5f$export$9df94c77b0746c3c;
module.exports["extractSubTasksProgress"] = $4af8820ea221ff5f$export$744e3a2674114c1d;
module.exports["extractUserAttributes"] = $4af8820ea221ff5f$export$6052f26bb463e370;
module.exports["extractReadTime"] = $4af8820ea221ff5f$export$cc4028b2878d0675;
module.exports["extractSmartLinkSentOn"] = $4af8820ea221ff5f$export$5c05c5b7ca37e36e;
module.exports["extractStoryPoints"] = $4af8820ea221ff5f$export$bdcea84d1550eb9d;
module.exports["extractMetaObjectId"] = $4af8820ea221ff5f$export$bec1443e3e33b166;
module.exports["extractMetaResourceType"] = $4af8820ea221ff5f$export$11d1314ebbee594e;
module.exports["extractMetaTenantId"] = $4af8820ea221ff5f$export$92037aea7f27bf7f;
module.exports["extractHostName"] = $4af8820ea221ff5f$export$f222ff3355b608d8;

});

parcelRegister("dLFOH", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $338f0872276e6db6$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $kzSaQ.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};
module.exports["extractPersonAssignedTo"] = $338f0872276e6db6$export$38a0979ebf273662;

});

parcelRegister("4P3K9", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $4fbbebc17c1a2887$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $kzSaQ.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $kzSaQ.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $4fbbebc17c1a2887$export$19ee667f3f7a6ec3;

});

parcelRegister("1pQH9", function(module, exports) {
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fBMbo = parcelRequire("fBMbo");


var $6KV13 = parcelRequire("6KV13");


var $boZKf = parcelRequire("boZKf");


var $2Stw8 = parcelRequire("2Stw8");

const $b39273305bd9d567$var$NEW_CARD_WIDTH_REM = 25;
const $b39273305bd9d567$var$HoverCardContainerStyle = null;
const $b39273305bd9d567$var$popupContainerStyles = null;
const $b39273305bd9d567$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $fBMbo.di)((0, $6KV13.default), (0, $boZKf.default));
    const { state: { status: status } } = (0, $6KV13.default)(url);
    const [showPrism, setShowPrism] = (0, $42omo.useState)(status === 'loading');
    (0, $42omo.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rko1mok _bfhk1bhr _16qs130s",
            (0, $2Stw8.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props
    }, children);
    return isAIEnabled ? /*#__PURE__*/ $42omo.createElement((0, $boZKf.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $b39273305bd9d567$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ $42omo.createElement($b39273305bd9d567$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props
    }, children);
var $b39273305bd9d567$export$2e2bcd8739ae039 = $b39273305bd9d567$var$ContentContainer;
module.exports["default"] = $b39273305bd9d567$export$2e2bcd8739ae039;

});

parcelRegister("boZKf", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cOrQJ = parcelRequire("cOrQJ");


var $e42nY = parcelRequire("e42nY");


var $ciHKQ = parcelRequire("ciHKQ");

const $211707d69efe87d9$var$contentStyles = null;
const $211707d69efe87d9$var$contentStylesPrismVisible = null;
const $211707d69efe87d9$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $211707d69efe87d9$var$popupContainerStyles = null;
const $211707d69efe87d9$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ $42omo.createElement((0, $e42nY.default), {
        palette: (0, $ciHKQ.AI_BORDER_PALETTE)[colorMode] ?? (0, $ciHKQ.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $gMc0m.default)([
            $211707d69efe87d9$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1mok _bfhk1bhr _16qs130s",
            "_v5649spz",
            isVisible && "_16qs1aef"
        ])
    }, children));
};
var $211707d69efe87d9$export$2e2bcd8739ae039 = $211707d69efe87d9$var$AIPrism;
module.exports["default"] = $211707d69efe87d9$export$2e2bcd8739ae039;

});

parcelRegister("e42nY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hkhVk = parcelRequire("hkhVk");

const $0807ece58a794f3e$var$borderContainerStyles = null;
const $0807ece58a794f3e$var$borderContentStyles = null; /**
                                   * The bulk of this file is originally from
                                   * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
                                   * with modifications.
                                   */ 
const $0807ece58a794f3e$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $hkhVk.default), {
        palette: palette,
        isMoving: isMoving,
        className: className
    }), isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ $42omo.createElement((0, $hkhVk.default), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        className: className
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1mok _16jlkb7n _1pbykb7n"
        ])
    }, children, " "));
var $0807ece58a794f3e$export$2e2bcd8739ae039 = $0807ece58a794f3e$var$AIGlowingBorder;
module.exports["default"] = $0807ece58a794f3e$export$2e2bcd8739ae039;

});

parcelRegister("hkhVk", function(module, exports) {
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

let $79bc72179a51708e$var$namespaceUUID = 0;
const $79bc72179a51708e$var$svgStyles = null;
const $79bc72179a51708e$var$blurredStyles = null;
const $79bc72179a51708e$var$notBlurredStyles = null; /**
                                * The bulk of this file is originally from
                                * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
                                * with modifications.
                                */ 
const $79bc72179a51708e$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $42omo.useRef)(null);
    const namespaceId = (0, $42omo.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $79bc72179a51708e$var$namespaceUUID;
        $79bc72179a51708e$var$namespaceUUID += 1;
    }
    (0, $42omo.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current; // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ $42omo.createElement("svg" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $42omo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $42omo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $42omo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $42omo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), /*#__PURE__*/ $42omo.createElement("g", {
        strokeWidth: "8"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $79bc72179a51708e$export$2e2bcd8739ae039 = $79bc72179a51708e$var$AnimatedSvgContainer;
module.exports["default"] = $79bc72179a51708e$export$2e2bcd8739ae039;

});

parcelRegister("ciHKQ", function(module, exports) {
const $24cc1de367735950$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $24cc1de367735950$export$23b7b83c7063ccfe = {
    dark: {
        blue: $24cc1de367735950$export$3088ed82e2905d1e.blue800,
        teal: $24cc1de367735950$export$3088ed82e2905d1e.teal500,
        yellow: $24cc1de367735950$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $24cc1de367735950$export$3088ed82e2905d1e.blue600,
        teal: $24cc1de367735950$export$3088ed82e2905d1e.teal300,
        yellow: $24cc1de367735950$export$3088ed82e2905d1e.yellow200
    }
};
module.exports["AI_BORDER_PALETTE"] = $24cc1de367735950$export$23b7b83c7063ccfe;

});

parcelRegister("2FHby", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $79vw2 = parcelRequire("79vw2");


var $7kN5H = parcelRequire("7kN5H");


var $hiPTU = parcelRequire("hiPTU");


var $afp1H = parcelRequire("afp1H");


var $8k046 = parcelRequire("8k046");


var $2R1C4 = parcelRequire("2R1C4");

var $Y5kOr = parcelRequire("Y5kOr");

const $7cef7844f9674345$var$titleBlockStyles = null;
const $7cef7844f9674345$var$mainTextStyles = null;
const $7cef7844f9674345$var$connectButtonStyles = null;
const $7cef7844f9674345$var$basePreviewStyles = null;
const $7cef7844f9674345$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $79vw2.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ $42omo.createElement("b", null, (0, $hiPTU.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7kN5H.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ $42omo.createElement((0, $8k046.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, $Y5kOr.default), {
        ignoreContainerPadding: true,
        testId: testId,
        className: (0, $gMc0m.default)([
            "_13li1mok _qrwq1mok _otyru2gc"
        ])
    }), /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-title`,
        className: (0, $gMc0m.default)([
            "_1bah1h6o _k48p1pd9 _19pku2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages)[titleMessageKey],
        values: {
            product: product
        }
    })), /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-content`,
        className: (0, $gMc0m.default)([
            "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages)[descriptiveMessageKey],
        values: {
            product: product,
            hostname: hostname
        }
    })), action && /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        className: (0, $gMc0m.default)([
            "_1bah1h6o _19pku2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        testId: `${testId}-button`,
        onClick: action?.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action?.text)));
};
var $7cef7844f9674345$export$2e2bcd8739ae039 = $7cef7844f9674345$var$HoverCardForbiddenView;
module.exports["default"] = $7cef7844f9674345$export$2e2bcd8739ae039;

});

parcelRegister("7kN5H", function(module, exports) {

var $afp1H = parcelRequire("afp1H");


var $lgqac = parcelRequire("lgqac");


var $hI9U7 = parcelRequire("hI9U7");


var $hiPTU = parcelRequire("hiPTU");

const $b560bbfc29780324$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $hiPTU.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $hI9U7.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $lgqac.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $afp1H.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $hI9U7.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $lgqac.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $afp1H.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $hI9U7.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $afp1H.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $hI9U7.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $lgqac.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $afp1H.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};
module.exports["extractRequestAccessContextImproved"] = $b560bbfc29780324$export$846c1540a86749e6;

});

parcelRegister("hI9U7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $afp1H = parcelRequire("afp1H");

const $8a01ffa8e2b5674f$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $afp1H.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });
module.exports["ForbiddenAction"] = $8a01ffa8e2b5674f$export$59f8830fb5467e35;

});

parcelRegister("hiPTU", function(module, exports) {
const $31b64bf218ef2796$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $31b64bf218ef2796$export$2e2bcd8739ae039 = $31b64bf218ef2796$var$extractHostname;
module.exports["default"] = $31b64bf218ef2796$export$2e2bcd8739ae039;

});

parcelRegister("3Yue4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $8k046 = parcelRequire("8k046");


var $f0wtW = parcelRequire("f0wtW");

var $MlN47 = parcelRequire("MlN47");

var $eqpYq = parcelRequire("eqpYq");

var $1lLfV = parcelRequire("1lLfV");

var $8zS2j = parcelRequire("8zS2j");

var $5znEc = parcelRequire("5znEc");


var $kwHRh = parcelRequire("kwHRh");


var $hggyn = parcelRequire("hggyn");

const $800f2bff5149f1e1$var$hiddenSnippetStyles = null;
const $800f2bff5149f1e1$var$titleBlockStyles = null;
const $800f2bff5149f1e1$var$snippetBlockCss = null;
const $800f2bff5149f1e1$var$actionBlockCss = null;
const $800f2bff5149f1e1$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $bIll3.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview
        }); // UFO will disregard this if authentication experience has not yet been started
        (0, $bIll3.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5TXU5.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5TXU5.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $42omo.useMemo)(()=>{
        return (0, $kwHRh.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(0);
    const snippetBlockRef = (0, $42omo.useRef)(null);
    const onSnippetRender = (0, $42omo.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $hggyn.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zS2j.default), {
        className: (0, $gMc0m.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8k046.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        ...titleBlockProps,
        metadataPosition: (0, $5TXU5.SmartLinkPosition).Top,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        primary: primary,
        secondary: secondary,
        maxLines: 1,
        size: (0, $5TXU5.SmartLinkSize).Medium
    }), isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqpYq.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zS2j.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        isHidden: true,
        className: (0, $gMc0m.default)([
            "_3um015vq _kqswstnw"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f0wtW.default), {
        onClick: onActionClick,
        spaceInline: "space.100",
        className: (0, $gMc0m.default)([
            "_n3td1b66"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $MlN47.default), null));
};
var $800f2bff5149f1e1$export$2e2bcd8739ae039 = $800f2bff5149f1e1$var$HoverCardResolvedView;
module.exports["default"] = $800f2bff5149f1e1$export$2e2bcd8739ae039;

});

parcelRegister("hggyn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5ctc0 = parcelRequire("5ctc0");


var $Y5kOr = parcelRequire("Y5kOr");

const $57f598b4bbab12f1$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $42omo.useRef)(false);
    const previewBlockRef = (0, $42omo.useRef)(null);
    const [showPreview, setShowPreview] = (0, $42omo.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $42omo.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $42omo.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $42omo.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $42omo.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $5ctc0.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Y5kOr.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $57f598b4bbab12f1$export$2e2bcd8739ae039 = $57f598b4bbab12f1$var$ImagePreview;
module.exports["default"] = $57f598b4bbab12f1$export$2e2bcd8739ae039;

});

parcelRegister("5ctc0", function(module, exports) {

var $lyclm = parcelRequire("lyclm");

var $iFI9k = parcelRequire("iFI9k");


var $5TXU5 = parcelRequire("5TXU5");

const $0f22550e7379302c$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $iFI9k.extractImage)(data);
    return url ? {
        type: (0, $5TXU5.MediaType).Image,
        url: url
    } : undefined;
};
var $0f22550e7379302c$export$2e2bcd8739ae039 = $0f22550e7379302c$var$extractPreview;
const $0f22550e7379302c$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $5TXU5.MediaType).Image,
            url: url
        } : undefined;
    }
    return $0f22550e7379302c$var$extractPreview(response.data);
};
module.exports["extractSmartLinkPreviewImage"] = $0f22550e7379302c$export$a79836076066b8b6;

});

parcelRegister("iFI9k", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $09d93d7349277f66$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
module.exports["extractImage"] = $09d93d7349277f66$export$4c753a1297cb9805;

});

parcelRegister("84jjJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $2R1C4 = parcelRequire("2R1C4");


var $7d67T = parcelRequire("7d67T");


var $hT8Jj = parcelRequire("hT8Jj");


var $4NlKF = parcelRequire("4NlKF");


var $aSUnJ = parcelRequire("aSUnJ");

const $9431eb578da6d4e9$var$loadingViewContainer = null;
const $9431eb578da6d4e9$var$skeletonContainer = null;
const $9431eb578da6d4e9$var$titleStyle = null;
const $9431eb578da6d4e9$var$titleBlockStyles = null;
const $9431eb578da6d4e9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $aSUnJ.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d67T.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...titleBlockProps,
        testId: `${testId}-title-block`,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NlKF.default), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), null),
        size: size
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `${testId}-title`,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), {
        height: `${lineHeightRem}rem`
    })), actionGroup), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem * 3}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hT8Jj.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }))));
};
var $9431eb578da6d4e9$export$2e2bcd8739ae039 = $9431eb578da6d4e9$var$HoverCardLoadingView;
module.exports["default"] = $9431eb578da6d4e9$export$2e2bcd8739ae039;

});

parcelRegister("5GuAS", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $79vw2 = parcelRequire("79vw2");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $a43ao = parcelRequire("a43ao");


var $226XV = parcelRequire("226XV");


var $86rMt = parcelRequire("86rMt");


var $8k046 = parcelRequire("8k046");


var $2R1C4 = parcelRequire("2R1C4");


var $7d67T = parcelRequire("7d67T");


var $jI5eg = parcelRequire("jI5eg");

const $aa8b3375130275dc$var$connectButtonStyles = null;
const $aa8b3375130275dc$var$titleBlockStyles = null;
const $aa8b3375130275dc$var$mainTextStyles = null;
const $aa8b3375130275dc$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $79vw2.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $226XV.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $a43ao.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleAuthorize = (0, $42omo.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5TXU5.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $42omo.useMemo)(()=>[
            {
                name: (0, $5TXU5.ActionName).CustomAction,
                content: /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
                    ...(0, $afp1H.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $8k046.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-title`,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _13mh1pd9"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $jI5eg.default), null), /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).connect_link_account_card_name,
        values: {
            context: providerName
        }
    })), /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-content`,
        className: (0, $gMc0m.default)([
            "_11c8dcr7 _19pku2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", null, /*#__PURE__*/ $42omo.createElement((0, $86rMt.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported
    }))), /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        testId: `${testId}-button`,
        className: (0, $gMc0m.default)([
            "_1bahesu3 _19pku2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $aa8b3375130275dc$export$2e2bcd8739ae039 = $aa8b3375130275dc$var$HoverCardUnauthorisedView;
module.exports["default"] = $aa8b3375130275dc$export$2e2bcd8739ae039;

});

parcelRegister("86rMt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $hX032 = parcelRequire("hX032");

/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4a1690bb7ffa863c$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $dh538.fg)('product-terminology-refresh') ? (0, $afp1H.messages).learn_more_about_connecting_account_appify : (0, $afp1H.messages).learn_more_about_connecting_account : (0, $afp1H.messages).learn_more_about_smart_links;
    const unauthorizedAccountDescriptionMessage = (0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() ? (0, $afp1H.messages).learn_more_about_connecting_account_experiment_shorter : (0, $dh538.fg)('product-terminology-refresh') ? (0, $afp1H.messages).connect_unauthorised_account_description_appify : (0, $afp1H.messages).connect_unauthorised_account_description;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...unauthorizedAccountDescriptionMessage,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $dh538.fg)('product-terminology-refresh') ? (0, $afp1H.messages).connect_unauthorised_account_description_no_provider_appify : (0, $afp1H.messages).connect_unauthorised_account_description_no_provider), (0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null) : ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: isProductIntegrationSupported ? (0, $5TXU5.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5TXU5.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        testId: `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), learnMoreMessage)));
};
var $4a1690bb7ffa863c$export$2e2bcd8739ae039 = $4a1690bb7ffa863c$var$UnauthorisedViewContent;
module.exports["default"] = $4a1690bb7ffa863c$export$2e2bcd8739ae039;

});

parcelRegister("3eIDF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $4gM1A = parcelRequire("4gM1A");

const $079645fb666cbdaa$var$styles = null; /**
                      * An anchor component to cover the entire container creating a clickable area.
                      * @internal
                      * @see `clickableContainer`
                      */ 
const $079645fb666cbdaa$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    return /*#__PURE__*/ $42omo.createElement("a" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: (0, $dh538.fg)('platform-linking-smart-card-layered-link-a11y') ? undefined : -1,
        "aria-hidden": (0, $dh538.fg)('platform-linking-smart-card-layered-link-a11y') ? undefined : true
    }, text);
};
var $079645fb666cbdaa$export$2e2bcd8739ae039 = $079645fb666cbdaa$var$LayeredLink;
module.exports["default"] = $079645fb666cbdaa$export$2e2bcd8739ae039;

});

parcelRegister("bTcnb", function(module, exports) {

var $79vw2 = parcelRequire("79vw2");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $7kN5H = parcelRequire("7kN5H");


var $ftgZs = parcelRequire("ftgZs");


var $6f2GC = parcelRequire("6f2GC");


var $5ctc0 = parcelRequire("5ctc0");


var $575f6 = parcelRequire("575f6");


var $kX2ZH = parcelRequire("kX2ZH");


var $imb12 = parcelRequire("imb12");


var $afp1H = parcelRequire("afp1H");


var $ivUmx = parcelRequire("ivUmx");


var $hX032 = parcelRequire("hX032");


var $4ibS1 = parcelRequire("4ibS1");

const $bce69080918b9451$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Pending:
        case (0, $5TXU5.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $6f2GC.default)(status, url, response, onClick),
                url: url
            };
        case (0, $5TXU5.SmartLinkStatus).Resolved:
            return (0, $ftgZs.default)(params);
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).NotFound:
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $575f6.extractErrorIcon)(response, status),
                linkTitle: (0, $6f2GC.default)(status, url, response, onClick),
                preview: (0, $5ctc0.extractSmartLinkPreviewImage)(response),
                provider: (0, $kX2ZH.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $5TXU5.InternalActionName).UnresolvedAction]: $bce69080918b9451$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                },
                ...(0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() && {
                    hostName: (0, $imb12.extractHostName)(response)
                }
            };
    }
};
const $bce69080918b9451$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $dh538.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $dh538.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $bce69080918b9451$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $79vw2.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $4ibS1.getForbiddenJsonLd)().meta;
            const access = (0, $7kN5H.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $bce69080918b9451$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $afp1H.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $ivUmx.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $afp1H.messages).connect_link_account_card_name,
                onClick: (0, $ivUmx.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5TXU5.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $afp1H.messages).cannot_find_link
            };
    }
};
module.exports["getContextByStatus"] = $bce69080918b9451$export$e68aec76e359e401;

});

parcelRegister("ftgZs", function(module, exports) {

var $4P3K9 = parcelRequire("4P3K9");

var $79vw2 = parcelRequire("79vw2");

var $aliCf = parcelRequire("aliCf");


var $dh538 = parcelRequire("dh538");


var $hX032 = parcelRequire("hX032");


var $3Qsou = parcelRequire("3Qsou");


var $d5zG4 = parcelRequire("d5zG4");


var $5ftEU = parcelRequire("5ftEU");


var $6f2GC = parcelRequire("6f2GC");


var $5ctc0 = parcelRequire("5ctc0");


var $5kcPY = parcelRequire("5kcPY");


var $1mkpa = parcelRequire("1mkpa");


var $575f6 = parcelRequire("575f6");


var $kX2ZH = parcelRequire("kX2ZH");


var $dUZ8o = parcelRequire("dUZ8o");


var $imb12 = parcelRequire("imb12");

const $cc6e2a82dcbb4550$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $79vw2.extractSmartLinkUrl)(response);
    return {
        actions: (0, $d5zG4.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        appliedToComponentsCount: (0, $imb12.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $imb12.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $imb12.extractAttachmentCount)(data),
        authorGroup: (0, $79vw2.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $4P3K9.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $5ftEU.extractPersonsUpdatedBy)(data),
        commentCount: (0, $imb12.extractSmartLinkCommentCount)(response),
        viewCount: (0, $imb12.extractViewCount)(data),
        reactCount: (0, $imb12.extractSmartLinkReactCount)(response),
        voteCount: (0, $imb12.extractVoteCount)(data),
        checklistProgress: (0, $imb12.extractChecklistProgress)(data),
        createdBy: (0, $79vw2.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $imb12.extractOwnedBy)(data),
        assignedTo: (0, $imb12.extractAssignedTo)(data),
        createdOn: (0, $79vw2.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $imb12.extractDueOn)(data),
        latestCommit: (0, $dUZ8o.extractLatestCommit)(data),
        linkIcon: (0, $575f6.extractSmartLinkIcon)(response),
        linkTitle: (0, $6f2GC.default)(status, props.url, response, onClick),
        location: (0, $imb12.extractLocation)(data),
        modifiedBy: (0, $79vw2.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $79vw2.extractSmartLinkModifiedOn)(response),
        preview: (0, $5ctc0.extractSmartLinkPreviewImage)(response),
        priority: (0, $5kcPY.default)(data),
        provider: (0, $kX2ZH.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $imb12.extractProgrammingLanguage)(data),
        readTime: (0, $imb12.extractReadTime)(data),
        sentOn: (0, $imb12.extractSmartLinkSentOn)(response),
        snippet: (0, $3Qsou.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $imb12.extractSourceBranch)(data),
        state: (0, $1mkpa.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel),
        subscriberCount: (0, $imb12.extractSubscriberCount)(data),
        subTasksProgress: (0, $imb12.extractSubTasksProgress)(data),
        storyPoints: (0, $imb12.extractStoryPoints)(data),
        targetBranch: (0, $imb12.extractTargetBranch)(data),
        ...(0, $dh538.fg)('platform-linking-user-attributes-component') && {
            userAttributes: (0, $imb12.extractUserAttributes)(data)
        },
        ...(0, $dh538.fg)('platform-linking-team-member-count-component') && {
            teamMemberCount: (0, $imb12.extractTeamMemberCount)(data)
        },
        url: url,
        ari: (0, $79vw2.extractSmartLinkAri)(response),
        type: (0, $aliCf.extractType)(data),
        meta: {
            objectId: (0, $imb12.extractMetaObjectId)(meta),
            resourceType: (0, $imb12.extractMetaResourceType)(meta),
            tenantId: (0, $imb12.extractMetaTenantId)(meta)
        },
        ...(0, $hX032.isNewBlockcardUnauthorizedRefreshExperimentEnabled)() && {
            hostName: (0, $imb12.extractHostName)(response)
        }
    };
};
var $cc6e2a82dcbb4550$export$2e2bcd8739ae039 = $cc6e2a82dcbb4550$var$extractFlexibleUiContext;
module.exports["default"] = $cc6e2a82dcbb4550$export$2e2bcd8739ae039;

});

parcelRegister("3Qsou", function(module, exports) {

var $lyclm = parcelRequire("lyclm");

const $89d55dabaa02345a$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $89d55dabaa02345a$export$8c6b9b49f358840 = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.description;
    return response?.data && $89d55dabaa02345a$export$db5a8500f6b6286e(response.data);
};
module.exports["extractSmartLinkSummary"] = $89d55dabaa02345a$export$8c6b9b49f358840;

});

parcelRegister("d5zG4", function(module, exports) {

var $5TXU5 = parcelRequire("5TXU5");


var $bZe40 = parcelRequire("bZe40");


var $fhiZH = parcelRequire("fhiZH");


var $1uqRs = parcelRequire("1uqRs");


var $aW1vb = parcelRequire("aW1vb");


var $6WoWK = parcelRequire("6WoWK");


var $euIFk = parcelRequire("euIFk");


var $cN6vm = parcelRequire("cN6vm");

const $97dbdd6e7a108abb$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $5TXU5.ActionName).CopyLinkAction]: (0, $1uqRs.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5TXU5.ActionName).DownloadAction]: (0, $aW1vb.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5TXU5.ActionName).FollowAction]: (0, $6WoWK.default)(response, actionOptions, id),
        [(0, $5TXU5.ActionName).PreviewAction]: (0, $euIFk.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        [(0, $5TXU5.ActionName).AutomationAction]: (0, $fhiZH.extractAutomationAction)(response),
        [(0, $5TXU5.InternalActionName).AISummaryAction]: (0, $bZe40.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5TXU5.InternalActionName).ViewRelatedLinksAction]: (0, $cN6vm.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};
module.exports["extractFlexibleCardActions"] = $97dbdd6e7a108abb$export$abe8d0ca1daa1755;

});

parcelRegister("bZe40", function(module, exports) {

var $2LWAa = parcelRequire("2LWAa");


var $kbh18 = parcelRequire("kbh18");


var $hcMBV = parcelRequire("hcMBV");

const $e8673adc3e68b528$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).AISummaryAction, actionOptions) || !(0, $kbh18.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};
module.exports["extractAISummaryAction"] = $e8673adc3e68b528$export$e7f7a50a8b8932df;

});

parcelRegister("2LWAa", function(module, exports) {
const $c909c594c41baf78$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};
module.exports["canShowAction"] = $c909c594c41baf78$export$2487b058456cca75;

});

parcelRegister("fhiZH", function(module, exports) {

var $5TXU5 = parcelRequire("5TXU5");

const $b78ad704e0ae6105$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5TXU5.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};
module.exports["extractAutomationAction"] = $b78ad704e0ae6105$export$f913cc6abf3ec084;

});

parcelRegister("1uqRs", function(module, exports) {

var $8TLGw = parcelRequire("8TLGw");

const $8c2f74fe1be4da73$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $8TLGw.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};
module.exports["extractCopyLinkClientAction"] = $8c2f74fe1be4da73$export$31ddd5c40039ce53;

});

parcelRegister("8TLGw", function(module, exports) {

var $79vw2 = parcelRequire("79vw2");


var $5TXU5 = parcelRequire("5TXU5");

var $hcMBV = parcelRequire("hcMBV");


var $226XV = parcelRequire("226XV");


var $2LWAa = parcelRequire("2LWAa");

const $fb7e4596bd230c75$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $79vw2.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5TXU5.ActionName).CopyLinkAction,
        definitionId: (0, $226XV.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $226XV.getExtensionKey)(response),
        id: id,
        resourceType: (0, $226XV.getResourceType)(response)
    };
};
module.exports["extractInvokeCopyLinkAction"] = $fb7e4596bd230c75$export$5ec86886067a062d;

});

parcelRegister("aW1vb", function(module, exports) {

var $eB2Ls = parcelRequire("eB2Ls");

const $9de9c0ec786639a8$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $eB2Ls.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};
module.exports["extractDownloadClientAction"] = $9de9c0ec786639a8$export$f6c386869a352b1f;

});

parcelRegister("eB2Ls", function(module, exports) {

var $79vw2 = parcelRequire("79vw2");


var $5TXU5 = parcelRequire("5TXU5");

var $hcMBV = parcelRequire("hcMBV");


var $226XV = parcelRequire("226XV");


var $ivUmx = parcelRequire("ivUmx");


var $2LWAa = parcelRequire("2LWAa");


var $fcTJU = parcelRequire("fcTJU");

const $dd9cc1ea5f7a02ad$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $fcTJU.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $79vw2.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $ivUmx.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5TXU5.ActionName).DownloadAction,
            definitionId: (0, $226XV.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $226XV.getExtensionKey)(response),
            id: id,
            resourceType: (0, $226XV.getResourceType)(response)
        };
    }
};
module.exports["extractInvokeDownloadAction"] = $dd9cc1ea5f7a02ad$export$ea97cd34c2ca86de;

});

parcelRegister("fcTJU", function(module, exports) {
const $bcab3e29f50fe6bc$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
module.exports["getActionsFromJsonLd"] = $bcab3e29f50fe6bc$export$8f031784a3a03b23;

});

parcelRegister("6WoWK", function(module, exports) {

var $l6lJr = parcelRequire("l6lJr");

var $aliCf = parcelRequire("aliCf");


var $4X6f2 = parcelRequire("4X6f2");


var $226XV = parcelRequire("226XV");


var $2LWAa = parcelRequire("2LWAa");


var $hcMBV = parcelRequire("hcMBV");


var $4LRV4 = parcelRequire("4LRV4");

const $e2c6b1a5cddedae9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $226XV.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $4LRV4.default)(data);
    const type = (0, $aliCf.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $4X6f2.SmartLinkActionType).FollowEntityAction || actionName === (0, $4X6f2.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $l6lJr.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $4X6f2.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $e2c6b1a5cddedae9$export$2e2bcd8739ae039 = $e2c6b1a5cddedae9$var$extractFollowAction;
module.exports["default"] = $e2c6b1a5cddedae9$export$2e2bcd8739ae039;

});

parcelRegister("4LRV4", function(module, exports) {
const $22e8dd570acdd9ca$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $22e8dd570acdd9ca$export$2e2bcd8739ae039 = $22e8dd570acdd9ca$var$extractServerAction;
module.exports["default"] = $22e8dd570acdd9ca$export$2e2bcd8739ae039;

});

parcelRegister("euIFk", function(module, exports) {

var $4gOU2 = parcelRequire("4gOU2");

const $eeffcaf65b928966$export$9f0d9100b079448 = (param)=>{
    const result = (0, $4gOU2.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};
module.exports["extractPreviewClientAction"] = $eeffcaf65b928966$export$9f0d9100b079448;

});

parcelRegister("4gOU2", function(module, exports) {

var $9JHBV = parcelRequire("9JHBV");

var $79vw2 = parcelRequire("79vw2");


var $7ee1w = parcelRequire("7ee1w");


var $1oCLl = parcelRequire("1oCLl");


var $5TXU5 = parcelRequire("5TXU5");

var $hcMBV = parcelRequire("hcMBV");


var $226XV = parcelRequire("226XV");


var $2LWAa = parcelRequire("2LWAa");


var $29GtD = parcelRequire("29GtD");


var $fHhRu = parcelRequire("fHhRu");


var $cUjGA = parcelRequire("cUjGA");


var $575f6 = parcelRequire("575f6");


var $eB2Ls = parcelRequire("eB2Ls");


var $dOvUN = parcelRequire("dOvUN");

const $0216c8d70d641474$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $79vw2.extractSmartLinkAri)(response);
    const url = (0, $79vw2.extractSmartLinkUrl)(response);
    const name = (0, $79vw2.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $7ee1w.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).PreviewAction, actionOptions)) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (0, $9JHBV.extractPreview)(data, 'web')?.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel && (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel_modal', 'cohort', 'test')) return;
    if (src) {
        const extensionKey = (0, $226XV.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $79vw2.extractSmartLinkEmbed)(response)?.src : undefined
                            }
                        });
                        (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        await (0, $29GtD.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $eB2Ls.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $dOvUN.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $fHhRu.extractIsSupportTheming)(meta),
                            isTrusted: (0, $cUjGA.extractIsTrusted)(meta),
                            linkIcon: (0, $575f6.extractLinkIcon)(response),
                            providerName: (0, $79vw2.extractSmartLinkProvider)(response)?.text,
                            onClose: onClose,
                            origin: origin,
                            src: (0, $79vw2.extractSmartLinkEmbed)(response)?.src,
                            title: (0, $79vw2.extractSmartLinkTitle)(response),
                            url: url,
                            size: actionOptions?.previewAction?.size,
                            isBlanketHidden: actionOptions?.previewAction?.hideBlanket,
                            ...(0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $5TXU5.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};
module.exports["extractInvokePreviewAction"] = $0216c8d70d641474$export$caf83f49e52ac0bb;

});

parcelRegister("7ee1w", function(module, exports) {
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $0342f45c1f755179$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $0342f45c1f755179$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $0342f45c1f755179$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $0342f45c1f755179$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $0342f45c1f755179$var$getUrlSearchParams(currentSearch);
            if (currentParams && $0342f45c1f755179$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $0342f45c1f755179$export$24def1b22639c691 = ()=>{
    return $0342f45c1f755179$export$9f140ed41af5108c() && $0342f45c1f755179$export$f274fcef361fe59d();
};
module.exports["isWithinPreviewPanelIFrame"] = $0342f45c1f755179$export$24def1b22639c691;

});

parcelRegister("29GtD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $1e2E5 = parcelRequire("1e2E5");

const $76698d8a364f0519$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $76698d8a364f0519$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $76698d8a364f0519$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($76698d8a364f0519$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $76698d8a364f0519$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("9oN54"));
    (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal.default, {
        ...props,
        iframeName: $76698d8a364f0519$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}
module.exports["openEmbedModal"] = $76698d8a364f0519$export$7859f96cd8cff034;

});

parcelRegister("9oN54", function(module, exports) {

let $6d7c6d5de96b4cc6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d7c6d5de96b4cc6$var$load("7ZIlR"),
    $6d7c6d5de96b4cc6$var$load("bFS2f"),
    $6d7c6d5de96b4cc6$var$load("hpePq"),
    $6d7c6d5de96b4cc6$var$load("Wowvf"),
    $6d7c6d5de96b4cc6$var$load("jTaSF"),
    $6d7c6d5de96b4cc6$var$load("7FRNR"),
    $6d7c6d5de96b4cc6$var$load("hhss7"),
    $6d7c6d5de96b4cc6$var$load("kDLrp")
]).then(()=>parcelRequire('6as51'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("fHhRu", function(module, exports) {

var $15w8R = parcelRequire("15w8R");

const $0f61633c27d66d37$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $15w8R.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};
module.exports["extractIsSupportTheming"] = $0f61633c27d66d37$export$38d755f52cdf4acb;

});

parcelRegister("15w8R", function(module, exports) {
const $c903d02fdad660aa$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $c903d02fdad660aa$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $c903d02fdad660aa$export$84a73a0383f58180 = 'JiraTask';
const $c903d02fdad660aa$export$c6c83963a9378a67 = 'JiraSubTask';
const $c903d02fdad660aa$export$58af3c426c111a6d = 'JiraStory';
const $c903d02fdad660aa$export$ac9898a63417219e = 'JiraBug';
const $c903d02fdad660aa$export$54db5e3fb12e39cd = 'JiraEpic';
const $c903d02fdad660aa$export$2f54a5a217202c85 = 'JiraIncident';
const $c903d02fdad660aa$export$d097371052bfc411 = 'JiraServiceRequest';
const $c903d02fdad660aa$export$efd9452ad16c6676 = 'JiraChange';
const $c903d02fdad660aa$export$2e7e70abb5d81f67 = 'JiraProblem';
const $c903d02fdad660aa$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $c903d02fdad660aa$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider',
    'avpviz-object-provider'
];
module.exports["CONFLUENCE_GENERATOR_ID"] = $c903d02fdad660aa$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $c903d02fdad660aa$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $c903d02fdad660aa$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $c903d02fdad660aa$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $c903d02fdad660aa$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $c903d02fdad660aa$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $c903d02fdad660aa$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $c903d02fdad660aa$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $c903d02fdad660aa$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $c903d02fdad660aa$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $c903d02fdad660aa$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $c903d02fdad660aa$export$ce25cfc40b280dbc;
module.exports["PROVIDER_KEYS_WITH_THEMING"] = $c903d02fdad660aa$export$fe44ce30fd8d131b;

});

parcelRegister("cUjGA", function(module, exports) {
const $b09d72911e8b5283$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};
module.exports["extractIsTrusted"] = $b09d72911e8b5283$export$4f3ffbb500daac5a;

});

parcelRegister("575f6", function(module, exports) {

var $lyclm = parcelRequire("lyclm");


var $5TXU5 = parcelRequire("5TXU5");


var $2CpuW = parcelRequire("2CpuW");


var $kn2iQ = parcelRequire("kn2iQ");


var $kX2ZH = parcelRequire("kX2ZH");

const $48fd38a3919fb96d$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $2CpuW.default)(data, renderers);
    return {
        ...(0, $kn2iQ.default)(data),
        render: render
    };
};
const $48fd38a3919fb96d$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kX2ZH.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5TXU5.IconType).Forbidden
            };
        case (0, $5TXU5.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5TXU5.IconType).Error
            };
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5TXU5.IconType).Default
            };
    }
};
const $48fd38a3919fb96d$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntityIcon)(response);
    return $48fd38a3919fb96d$export$43612bed147eae48(response, renderers);
};
module.exports["extractLinkIcon"] = $48fd38a3919fb96d$export$43612bed147eae48;
module.exports["extractErrorIcon"] = $48fd38a3919fb96d$export$bdd29be9b0395931;
module.exports["extractSmartLinkIcon"] = $48fd38a3919fb96d$export$35040aed9264b11c;

});

parcelRegister("2CpuW", function(module, exports) {
const $ecff103eb394f1ce$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $ecff103eb394f1ce$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $ecff103eb394f1ce$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $ecff103eb394f1ce$export$2e2bcd8739ae039 = $ecff103eb394f1ce$var$extractIconRenderer;
module.exports["default"] = $ecff103eb394f1ce$export$2e2bcd8739ae039;

});

parcelRegister("kn2iQ", function(module, exports) {

var $hUifo = parcelRequire("hUifo");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $7hXqf = parcelRequire("7hXqf");


var $uAXxz = parcelRequire("uAXxz");


var $8sXiv = parcelRequire("8sXiv");


var $15w8R = parcelRequire("15w8R");


var $2OB54 = parcelRequire("2OB54");


var $f6wMd = parcelRequire("f6wMd");


var $8fQ4N = parcelRequire("8fQ4N");


var $kX2ZH = parcelRequire("kX2ZH");


var $dVnIN = parcelRequire("dVnIN");

const $db64d56f9a1152ff$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $8sXiv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $db64d56f9a1152ff$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $uAXxz.extractorPriorityMap)[b] - (0, $uAXxz.extractorPriorityMap)[a])[0] : type;
};
const $db64d56f9a1152ff$var$isJiraProvider = (provider)=>provider === (0, $15w8R.JIRA_GENERATOR_ID);
function $db64d56f9a1152ff$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $f6wMd.default)(fileFormat);
    const documentTypeIcon = $db64d56f9a1152ff$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $2OB54.default)(type, label, providerId);
    return (0, $7hXqf.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $db64d56f9a1152ff$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Task,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Task,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Project,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Project,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Commit,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Commit,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).PullRequest,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).PullRequest,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Branch,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Branch,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Repo,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Repo,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5TXU5.IconType).Task,
                label: taskLabel
            };
            if ($db64d56f9a1152ff$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $db64d56f9a1152ff$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $8fQ4N.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $db64d56f9a1152ff$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $hUifo.extractTitle)(data);
    const type = $db64d56f9a1152ff$var$extractType(data);
    const urlIcon = (0, $dVnIN.default)(data.icon, label);
    const providerIcon = (0, $kX2ZH.default)(data);
    return $db64d56f9a1152ff$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $db64d56f9a1152ff$export$2e2bcd8739ae039 = $db64d56f9a1152ff$var$extractJsonldDataIcon;
module.exports["default"] = $db64d56f9a1152ff$export$2e2bcd8739ae039;

});

parcelRegister("7hXqf", function(module, exports) {
/**
 * Options required to prioritise which icon to show
 */ function $776748d0c66c7fba$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}
module.exports["prioritiseIcon"] = $776748d0c66c7fba$export$65e47eb22a387a86;

});

parcelRegister("uAXxz", function(module, exports) {
const $2e2993a3a04453b8$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
module.exports["extractorPriorityMap"] = $2e2993a3a04453b8$export$e0deaeb4a2dfe2b4;

});

parcelRegister("8sXiv", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

const $50b1c4035dc2416d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
module.exports["extractTaskType"] = $50b1c4035dc2416d$export$ed3fd59180514d27;

});

parcelRegister("2OB54", function(module, exports) {

var $ccQw1 = parcelRequire("ccQw1");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");

/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $43d4ba8ed352f0e6$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Blog,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Blog,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $ccQw1.isConfluenceGenerator)(providerId)) return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).LiveDocument,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).LiveDocument,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Live Document'
            };
            else return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).File,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).File,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Document,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Document,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Presentation,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Presentation,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Spreadsheet,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Spreadsheet,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Template,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Template,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return (0, $dh538.fg)('navx-2827-eslint-object-translation-smart-links') ? {
                icon: (0, $5TXU5.IconType).Document,
                label: label
            } : {
                icon: (0, $5TXU5.IconType).Document,
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $43d4ba8ed352f0e6$export$2e2bcd8739ae039 = $43d4ba8ed352f0e6$var$extractDocumentTypeIcon;
module.exports["default"] = $43d4ba8ed352f0e6$export$2e2bcd8739ae039;

});

parcelRegister("8fQ4N", function(module, exports) {

var $5TXU5 = parcelRequire("5TXU5");

const $3057ac52417f53cb$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5TXU5.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5TXU5.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5TXU5.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5TXU5.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5TXU5.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5TXU5.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5TXU5.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5TXU5.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5TXU5.IconType).Task,
                label: label
            };
    }
};
var $3057ac52417f53cb$export$2e2bcd8739ae039 = $3057ac52417f53cb$var$extractJiraTaskIcon;
module.exports["default"] = $3057ac52417f53cb$export$2e2bcd8739ae039;

});

parcelRegister("kX2ZH", function(module, exports) {

var $lyclm = parcelRequire("lyclm");

var $hUifo = parcelRequire("hUifo");


var $5TXU5 = parcelRequire("5TXU5");


var $15w8R = parcelRequire("15w8R");


var $dVnIN = parcelRequire("dVnIN");

/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $65f5e55fe221e038$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $hUifo.extractTitle)(data);
    if (provider === (0, $15w8R.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5TXU5.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $15w8R.JIRA_GENERATOR_ID)) return {
        icon: (0, $5TXU5.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $dVnIN.default)(icon, label);
};
var $65f5e55fe221e038$export$2e2bcd8739ae039 = $65f5e55fe221e038$var$extractProviderIcon;
const $65f5e55fe221e038$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const provider = (0, $lyclm.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $15w8R.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5TXU5.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $15w8R.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5TXU5.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $lyclm.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $65f5e55fe221e038$var$extractProviderIcon(response.data);
};
module.exports["default"] = $65f5e55fe221e038$export$2e2bcd8739ae039;
module.exports["extractSmartLinkProviderIcon"] = $65f5e55fe221e038$export$5def189f04eea025;

});

parcelRegister("dVnIN", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $1af37185996e64e9$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $8hlRK.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $1af37185996e64e9$export$2e2bcd8739ae039 = $1af37185996e64e9$var$extractUrlIcon;
module.exports["default"] = $1af37185996e64e9$export$2e2bcd8739ae039;

});

parcelRegister("dOvUN", function(module, exports) {

var $l6lJr = parcelRequire("l6lJr");


var $hcMBV = parcelRequire("hcMBV");


var $226XV = parcelRequire("226XV");


var $ivUmx = parcelRequire("ivUmx");


var $2LWAa = parcelRequire("2LWAa");


var $fcTJU = parcelRequire("fcTJU");

const $7b2d7b35c23c90ae$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $l6lJr.extractLink)(data);
    const viewActionExists = (0, $fcTJU.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $ivUmx.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $226XV.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $226XV.getExtensionKey)(response),
        id: id,
        resourceType: (0, $226XV.getResourceType)(response)
    };
};
module.exports["extractInvokeViewAction"] = $7b2d7b35c23c90ae$export$88c5813cfbbe4e4c;

});

parcelRegister("cN6vm", function(module, exports) {

var $79vw2 = parcelRequire("79vw2");

const $2508fbc57d702d88$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $79vw2.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};
module.exports["extractViewRelatedLinksAction"] = $2508fbc57d702d88$export$debae7424a0231b9;

});

parcelRegister("5ftEU", function(module, exports) {

var $96Gxc = parcelRequire("96Gxc");

var $kzSaQ = parcelRequire("kzSaQ");

const $bb6eac6463daf31f$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $96Gxc.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $kzSaQ.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};
module.exports["extractPersonsUpdatedBy"] = $bb6eac6463daf31f$export$216e4f6aa7c169b8;

});

parcelRegister("96Gxc", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $335da40493fc9d85$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $kzSaQ.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $kzSaQ.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
module.exports["extractMembers"] = $335da40493fc9d85$export$6281d080d62a0719;

});

parcelRegister("6f2GC", function(module, exports) {

var $79vw2 = parcelRequire("79vw2");


var $5TXU5 = parcelRequire("5TXU5");

const $d9f3dbb8591ea96a$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $79vw2.extractSmartLinkUrl)(response);
    const url = status === (0, $5TXU5.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $79vw2.extractSmartLinkTitle)(response);
    const text = status === (0, $5TXU5.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $d9f3dbb8591ea96a$export$2e2bcd8739ae039 = $d9f3dbb8591ea96a$var$extractLinkTitle;
module.exports["default"] = $d9f3dbb8591ea96a$export$2e2bcd8739ae039;

});

parcelRegister("5kcPY", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");


var $5TXU5 = parcelRequire("5TXU5");

const $74fe51f061491681$var$priorityMapper = {
    blocker: (0, $5TXU5.IconType).PriorityBlocker,
    critical: (0, $5TXU5.IconType).PriorityCritical,
    high: (0, $5TXU5.IconType).PriorityHigh,
    highest: (0, $5TXU5.IconType).PriorityHighest,
    low: (0, $5TXU5.IconType).PriorityLow,
    lowest: (0, $5TXU5.IconType).PriorityLowest,
    major: (0, $5TXU5.IconType).PriorityMajor,
    medium: (0, $5TXU5.IconType).PriorityMedium,
    minor: (0, $5TXU5.IconType).PriorityMinor,
    trivial: (0, $5TXU5.IconType).PriorityTrivial,
    undefined: (0, $5TXU5.IconType).PriorityUndefined
};
const $74fe51f061491681$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $74fe51f061491681$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $74fe51f061491681$export$2e2bcd8739ae039 = $74fe51f061491681$var$extractPriority;
module.exports["default"] = $74fe51f061491681$export$2e2bcd8739ae039;

});

parcelRegister("1mkpa", function(module, exports) {

var $l6lJr = parcelRequire("l6lJr");


var $226XV = parcelRequire("226XV");


var $2LWAa = parcelRequire("2LWAa");


var $hcMBV = parcelRequire("hcMBV");


var $4gOU2 = parcelRequire("4gOU2");


var $dKrmg = parcelRequire("dKrmg");


var $4LRV4 = parcelRequire("4LRV4");

const $a4bf3e45dcc07f8b$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $a4bf3e45dcc07f8b$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    const extensionKey = (0, $226XV.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $4LRV4.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $a4bf3e45dcc07f8b$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $l6lJr.extractLink)(data);
    const invokePreviewAction = response ? (0, $4gOU2.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $a4bf3e45dcc07f8b$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $a4bf3e45dcc07f8b$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $dKrmg.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $a4bf3e45dcc07f8b$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel);
    return {
        ...lozenge,
        action: action
    };
};
var $a4bf3e45dcc07f8b$export$2e2bcd8739ae039 = $a4bf3e45dcc07f8b$var$extractState;
module.exports["default"] = $a4bf3e45dcc07f8b$export$2e2bcd8739ae039;

});

parcelRegister("dKrmg", function(module, exports) {

var $aliCf = parcelRequire("aliCf");


var $jJuER = parcelRequire("jJuER");


var $eT7Ev = parcelRequire("eT7Ev");


var $i3QgA = parcelRequire("i3QgA");


var $8sXiv = parcelRequire("8sXiv");

const $35ed8229f3b3cbd6$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $aliCf.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $eT7Ev.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $i3QgA.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $35ed8229f3b3cbd6$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $jJuER.extractState)(jsonLd);
    }
};
const $35ed8229f3b3cbd6$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $8sXiv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};
module.exports["extractLozenge"] = $35ed8229f3b3cbd6$export$e5da155556a77bca;

});

parcelRegister("jJuER", function(module, exports) {

var $9uon3 = parcelRequire("9uon3");

// Maps accent color short names to their corresponding background and text colors
const $2218d42ba61dc0c3$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $2218d42ba61dc0c3$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $9uon3.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $9uon3.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $2218d42ba61dc0c3$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};
module.exports["extractState"] = $2218d42ba61dc0c3$export$5e4074cbce6574c7;

});

parcelRegister("9uon3", function(module, exports) {
const $62de36893d312d67$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $62de36893d312d67$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $62de36893d312d67$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $62de36893d312d67$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $62de36893d312d67$export$772610da74ddbc07 = [
    'current'
];
module.exports["isValidAppearance"] = $62de36893d312d67$export$ce6b5b303f8e3c99;
module.exports["VALID_STATES"] = $62de36893d312d67$export$7b1deaaad25d1dc1;
module.exports["OMIT_STATES"] = $62de36893d312d67$export$772610da74ddbc07;

});

parcelRegister("eT7Ev", function(module, exports) {

var $9uon3 = parcelRequire("9uon3");

const $107358540664e913$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($107358540664e913$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $107358540664e913$var$extractTagItem(tag);
    }
};
const $107358540664e913$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $9uon3.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};
module.exports["extractTag"] = $107358540664e913$export$962a8da34cf78a4f;

});

parcelRegister("i3QgA", function(module, exports) {
const $361da8e075cf72f7$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};
module.exports["extractTaskStatus"] = $361da8e075cf72f7$export$7698df1946deda72;

});

parcelRegister("dUZ8o", function(module, exports) {
const $6850aa7564532ebc$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};
module.exports["extractLatestCommit"] = $6850aa7564532ebc$export$f222392162cff0d8;

});

parcelRegister("iWvOt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $Y0OXK = parcelRequire("Y0OXK");


var $dh538 = parcelRequire("dh538");


var $hL5V3 = parcelRequire("hL5V3");

const $f9f9ad585f1b3a08$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hL5V3.useConfluencePageData)(props.src || '', extensionKey || '') : undefined;
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData && (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Y0OXK.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};
module.exports["IFrame"] = $f9f9ad585f1b3a08$export$b32b5f1ee4493319;

});

parcelRegister("Y0OXK", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");


var $a4Weo = parcelRequire("a4Weo");


var $eNWGp = parcelRequire("eNWGp");

const $7e20740578e340e4$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $a4Weo.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eNWGp.Page), {
            ...props
        })
    });
module.exports["Page"] = $7e20740578e340e4$export$6955bcca4cd3539f;

});

parcelRegister("a4Weo", function(module, exports) {

var $504sF = parcelRequire("504sF");


var $5GGZL = parcelRequire("5GGZL");

const $eae070da32ac21dd$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $504sF.default;
        case 'en-US':
        default:
            return 0, $5GGZL.default;
    }
};
var $eae070da32ac21dd$export$2e2bcd8739ae039 = $eae070da32ac21dd$var$fetchTranslations;
module.exports["default"] = $eae070da32ac21dd$export$2e2bcd8739ae039;

});

parcelRegister("504sF", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e428a1b86b9241f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $0e428a1b86b9241f$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("5GGZL", function(module, exports) {
$parcel$export(module.exports, "default", () => $45dca5869897ff09$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $45dca5869897ff09$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("eNWGp", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7k8Uw = parcelRequire("7k8Uw");


var $8C5kA = parcelRequire("8C5kA");


var $6uh00 = parcelRequire("6uh00");


var $5qNp3 = parcelRequire("5qNp3");

const $172be5db228fd17c$var$ViewComponent = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uh00.ViewPage), {
        locale: locale,
        ...props
    });
};
const $172be5db228fd17c$var$EditComponent = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5qNp3.EditPage), {
        locale: locale,
        ...props
    });
};
const $172be5db228fd17c$export$6955bcca4cd3539f = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7k8Uw.Page), {
        locale: locale,
        ...props,
        viewComponent: $172be5db228fd17c$var$ViewComponent,
        editComponent: $172be5db228fd17c$var$EditComponent
    });
};
module.exports["Page"] = $172be5db228fd17c$export$6955bcca4cd3539f;

});

parcelRegister("6uh00", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");


var $a4Weo = parcelRequire("a4Weo");


var $ktyYp = parcelRequire("ktyYp");

const $6d62a53500c7e32b$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $a4Weo.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ktyYp.ViewPage), {
            ...props
        })
    });
module.exports["ViewPage"] = $6d62a53500c7e32b$export$767e3006bdbb424a;

});

parcelRegister("ktyYp", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aI44c = parcelRequire("aI44c");


var $8C5kA = parcelRequire("8C5kA");

const $216b1f3eb7fd7629$export$767e3006bdbb424a = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aI44c.ViewPage), {
        locale: locale,
        ...props
    });
};
module.exports["ViewPage"] = $216b1f3eb7fd7629$export$767e3006bdbb424a;

});

parcelRegister("5qNp3", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");


var $a4Weo = parcelRequire("a4Weo");


var $657oH = parcelRequire("657oH");

const $8690a9fa0f1ae334$export$1fea75498367c4ac = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $a4Weo.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $657oH.EditPage), {
            ...props
        })
    });
module.exports["EditPage"] = $8690a9fa0f1ae334$export$1fea75498367c4ac;

});

parcelRegister("657oH", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aiCKw = parcelRequire("aiCKw");


var $8C5kA = parcelRequire("8C5kA");

const $015976cb7cb7475e$export$1fea75498367c4ac = (props)=>{
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aiCKw.EditPage), {
        locale: locale,
        ...props
    });
};
module.exports["EditPage"] = $015976cb7cb7475e$export$1fea75498367c4ac;

});

parcelRegister("hL5V3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $bRSdj = parcelRequire("bRSdj");

var $j6S25 = parcelRequire("j6S25");

var $7e0969c4e751a56a$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $7e0969c4e751a56a$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $7e0969c4e751a56a$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $7e0969c4e751a56a$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $42omo.useMemo)(()=>{
        if (!(0, $dh538.fg)('platform_deprecate_lp_cc_embed')) return undefined;
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($7e0969c4e751a56a$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $j6S25.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $42omo.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $bRSdj.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};
module.exports["useConfluencePageData"] = $7e0969c4e751a56a$export$10fb2803bc7b79fc;

});

parcelRegister("4vCA9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a879f42abb981ca6$var$placeholderShimmer = null;
const $a879f42abb981ca6$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $a879f42abb981ca6$var$spanSkeletonStyles = null;
const $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $a879f42abb981ca6$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $gMc0m.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $a879f42abb981ca6$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $gMc0m.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $a879f42abb981ca6$export$2e2bcd8739ae039 = $a879f42abb981ca6$export$8f31e4c4a37b8e9c;
module.exports["SpanSkeleton"] = $a879f42abb981ca6$export$85d5658002cae6ce;
module.exports["Skeleton"] = $a879f42abb981ca6$export$8f31e4c4a37b8e9c;

});


$parcel$global.rlb("7ZIlR")
//# sourceMappingURL=component-lazy.1e9720e3.js.map
